export default {
  TEXT: 'text',
  QNA: 'qna',
};
